import {combineReducers} from 'redux'
import config from './config'
import leftSidebar from './left-sidebar'
import palettes from './palettes'
import navigation from './navigation'
import user from './user'
import filterEntrance from "./filterEntrance";
import filterTicket from "./filterTicket";
import filterTurnstile from "./filterTurnstile";
import turnstileSort from "./turnstileSort";
import pages from "./pages";
import subjects from "./subjects";
import dashboardRange from "./dashboardRange";
import mapEditor from "./mapEditor";
import filterTurnstileCommand from "./filterTurnstileCommand";



export const rootReducer = combineReducers({
  navigation,
  config,
  leftSidebar,
  palettes,
  user,
  filterEntrance,
  filterTicket,
  filterTurnstile,
  turnstileSort,
  pages,
  subjects,
  dashboardRange,
  mapEditor,
  filterTurnstileCommand
})


